import React from "react";

// need to delete this file
export const FAKE_MEETING_ROOM_LIST = [
  {
    id: "1",
    imgUrl:
      "https://meet-production.s3.amazonaws.com/images/space_image/image/5b8ac48c-5896-4ed8-b48b-a1a048cd4b24/small_5A_-_5_People.jpg",
    name: "Room 4B",
    location: "New York",
    capacity: 6,
    offeringSlug: "werqwise-meeting-rooms",
    spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
  },
  {
    id: "2",
    imgUrl:
      "https://meet-production.s3.amazonaws.com/images/space_image/image/5b8ac48c-5896-4ed8-b48b-a1a048cd4b24/small_5A_-_5_People.jpg",
    name: "Room 4B",
    location: "New York",
    capacity: 1,
    offeringSlug: "werqwise-meeting-rooms",
    spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
  },
  {
    id: "3",
    imgUrl:
      "https://meet-production.s3.amazonaws.com/images/space_image/image/5b8ac48c-5896-4ed8-b48b-a1a048cd4b24/small_5A_-_5_People.jpg",
    name: "Room 4B",
    location: "New York",
    capacity: 6,
    offeringSlug: "werqwise-meeting-rooms",
    spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
  },
  {
    id: "4",
    imgUrl:
      "https://meet-production.s3.amazonaws.com/images/space_image/image/5b8ac48c-5896-4ed8-b48b-a1a048cd4b24/small_5A_-_5_People.jpg",
    name: "Room 4B",
    location: "New York",
    capacity: 6,
    offeringSlug: "werqwise-meeting-rooms",
    spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
  },
  {
    id: "5",
    imgUrl:
      "https://meet-production.s3.amazonaws.com/images/space_image/image/5b8ac48c-5896-4ed8-b48b-a1a048cd4b24/small_5A_-_5_People.jpg",
    name: "Room 4B",
    location: "New York",
    capacity: 6,
    offeringSlug: "werqwise-meeting-rooms",
    spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
  },
  {
    id: "6",
    imgUrl:
      "https://meet-production.s3.amazonaws.com/images/space_image/image/5b8ac48c-5896-4ed8-b48b-a1a048cd4b24/small_5A_-_5_People.jpg",
    name: "Room 4B",
    location: "New York",
    capacity: 6,
    offeringSlug: "werqwise-meeting-rooms",
    spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
  },
  {
    id: "7",
    imgUrl:
      "https://meet-production.s3.amazonaws.com/images/space_image/image/5b8ac48c-5896-4ed8-b48b-a1a048cd4b24/small_5A_-_5_People.jpg",
    name: "Room 4B",
    location: "New York",
    capacity: 6,
    offeringSlug: "werqwise-meeting-rooms",
    spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
  },
];

export const FAKE_MEMBERSIP_MEETING_ROOM_DETAILS = {
  name: "Meeting Room 4B",
  description:
    "Book 12 membership hours per month. 15% off additional bookings.",
  capacity: 6,
  usedCount: 12,
  totalCount: 12,
  imageUrl:
    "https://meet-production.s3.amazonaws.com/images/space_image/image/8794f236-a6a2-4229-b759-c9c80acafec5/small_nomad-broadway-1.jpeg",
  location: "612 South Broadway",
  bookingEmail: "joe@mail.com",
  spaceId: "d26e578b-9a8e-414d-bee5-e654fac817b3",
};

export const FAKE_PAYMENT_DETAILS = {
  items: [
    { label: "Membership passes x 1", price: "$0.00" },
    {
      label: "$23 x 4 days",
      price: "$92.00",
      tooltip: (
        <div>
          We’ve chosen the best possible price for you based on your selections.
        </div>
      ),
    },
    {
      label: "Member discount (-15%)",
      price: "-$13.80",
      isDiscount: true,
    },
    { label: "Taxes (13%)", price: "$10.17" },
  ],
  card: {
    number: "1234 1234 1234 1234",
    expiration: { month: 12, year: 34 },
    cvc: 123,
    firstName: "John",
    lastName: "Smith",
    streetAddess: "707 Wilshire Blvd St.",
    country: "USA",
    city: "Los Angeles",
    state: "CA",
  },
  total: "$153.33",
  currency: "USD",
};
